import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IContainerReduxState = {
    formSearch: undefined,
};

export const containerSlice = createSlice({
    name: 'container',
    initialState,
    reducers: {
        setFormSearch: (
            state,
            action: PayloadAction<Partial<IContainerSearchConditions> | undefined>,
        ) => {
            state.formSearch = action.payload;
        },
    },
});

export const { setFormSearch } = containerSlice.actions;

export default containerSlice.reducer;
